import SEO from '../../Components/SEO';
import Breadcrumb from '../../Components/Breadcrumb';
import { ActivityLayout } from '../../Components/activity-layout';

const speaking = '/Images/speaking3.webp';

const levels = [
  {
    level: 'B2',
    cards: [
      {
        title: 'Speaking Topics',
            image: '/Images/speaking3.webp',
        level: 'B2',
        desc:
          'Vocabulary exercises, flashcards and quizzes to help you improve and have greater success on exams.',
        links: [
          {
            text: 'Speaking Topics',
            to: '/speaking-exercises/speaking-topics',
            level: 'B2',
          },
        ],
      },
      {
        title: 'Picture Comparison',
        image: '/Images/steps1.webp',
        level: 'B2',
        desc:
          'Vocabulary exercises, flashcards and quizzes to help you improve and have greater success on exams.',
        links: [
          {
            text: 'Picture Comparison',
            to: '/speaking-exercises/picture-comparison',
            level: 'B2',
          },
        ],
      },
    ],
  },
];

const Speakingexercises = () => {
  return (
      <ActivityLayout
        title="Speaking Exercises"
        image={speaking}
        intro="Here is a collection of speaking exercises to do. The exercises are divided by categories which correspond to exam levels. Each category here has 10 exercises, but there are more once you go to the page. Keep checking back as I am always adding new exercises."
        levels={levels}
      >
      <SEO
        title="Free English Speaking Lesson Plans & Activities for ESL Teachers"
        description="Ready-to-use speaking lesson plans for online ESL teachers. Picture comparisons, discussion topics, and role-plays organized by CEFR level and topic. Perfect for 1-to-1 conversation classes or group speaking practice."
        name="English Exam Exercises"
        type="article"
        image={speaking} />
      <Breadcrumb />
    </ActivityLayout>
  );
};

export default Speakingexercises;
